import React from 'react';
import styles from './styles.module.scss';
interface LogoProps {
  size: string;
}
const Logo: React.FC<LogoProps> = ({ size }: LogoProps): JSX.Element => {
  return (
    <div>
      {size === 'large' ? (
        <img className={styles.img} src="/skill-matrix-logo-l.png" />
      ) : size === 'medium' ? (
        <img className={styles['img-medium']} src="/skill-matrix-logo-l.png" />
      ) : (
        <img className={styles['img-small']} src="/skill-matrix-logo-s.png" />
      )}
    </div>
  );
};

export default Logo;
